import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, FileText } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { RON, track } from "@/lib/api";

export const DocumentCard = ({ doc, index = 0 }) => {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.4) }}
    >
      <Card
        data-testid={`document-card-${doc.slug}`}
        className="group h-full flex flex-col p-6 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:border-blue-400 hover:shadow-lg hover:shadow-blue-100/50 dark:hover:shadow-none transition-all cursor-pointer"
        onClick={() => {
          track("document_view", { slug: doc.slug });
          navigate(`/documente/${doc.slug}`);
        }}
      >
        <div className="flex items-start justify-between mb-4">
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-blue-50 dark:bg-blue-950 text-blue-600">
            <FileText className="w-5 h-5" />
          </span>
          <Badge className="bg-sky-100 text-sky-700 hover:bg-sky-100 dark:bg-sky-950 dark:text-sky-300 font-semibold rounded-full">
            {RON(doc.price)}
          </Badge>
        </div>
        <span className="text-xs font-semibold uppercase tracking-widest text-blue-600 mb-1">
          {doc.category}
        </span>
        <h3 className="font-heading font-bold text-lg text-slate-900 dark:text-white leading-snug mb-2">
          {doc.title}
        </h3>
        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed flex-1">
          {doc.description}
        </p>
        <Button
          data-testid={`generate-btn-${doc.slug}`}
          variant="ghost"
          className="mt-5 justify-between text-blue-600 hover:text-blue-700 hover:bg-blue-50 dark:hover:bg-blue-950 font-semibold px-3 group-hover:translate-x-0"
        >
          Generează
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </Button>
      </Card>
    </motion.div>
  );
};
